import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgDrawLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3279 5.40348L12.6464 1.72196L14.0531 0.305322C14.1462 0.208764 14.2578 0.131987 14.3812 0.0795274C14.5046 0.0270683 14.6373 0 14.7714 0C14.9055 0 15.0382 0.0270683 15.1616 0.0795274C15.2851 0.131987 15.3967 0.208764 15.4897 0.305322L17.6947 2.51017C17.7912 2.60324 17.868 2.71484 17.9205 2.83826C17.9729 2.96169 18 3.09436 18 3.22847C18 3.36258 17.9729 3.49538 17.9205 3.6188C17.868 3.74223 17.7912 3.85383 17.6947 3.9469L16.3279 5.40348ZM4.43545 17.2959L0.444738 17.9943C0.384753 18.0048 0.323058 18.0008 0.26498 17.9825C0.206902 17.9641 0.154106 17.932 0.111041 17.8889C0.0679763 17.8459 0.0359645 17.7931 0.0176306 17.735C-0.000703392 17.6769 -0.00483877 17.6153 0.00569545 17.5553L0.704144 13.5646L4.43545 17.2959ZM1.58384 12.9L11.9719 2.51913L15.6531 6.20295L5.26507 16.5838L1.58384 12.9ZM20.9883 22.0949C21.5994 22.9045 22.4263 24 24 24V22.1249C23.3253 22.1249 23.0188 21.7186 22.4361 20.9374C22.428 20.9267 22.4199 20.9159 22.4117 20.9051C21.8006 20.0955 20.9737 19 19.4 19C17.8229 19 17.0252 20.0593 16.419 20.8644C16.4004 20.889 16.3821 20.9133 16.3639 20.9374C15.7814 21.7186 15.4441 22.1249 14.8 22.1249C14.1253 22.1249 13.8188 21.7186 13.2361 20.9374C13.2177 20.9131 13.1992 20.8885 13.1805 20.8637C12.5741 20.0587 11.7767 19 10.2 19C8.62287 19 7.8252 20.0593 7.21895 20.8644C7.20045 20.889 7.18211 20.9133 7.16395 20.9374C6.58144 21.7186 6.24411 22.1249 5.6 22.1249C4.92528 22.1249 4.61878 21.7186 4.03605 20.9374L4.0117 20.9051C3.40061 20.0955 2.57371 19 1 19V20.8751C1.67472 20.8751 1.98122 21.2814 2.56395 22.0626L2.5883 22.0949C3.19939 22.9045 4.02629 24 5.6 24C7.17713 24 7.9748 22.9407 8.58105 22.1356C8.59956 22.111 8.61789 22.0867 8.63605 22.0626C9.21856 21.2814 9.52528 20.8751 10.2 20.8751C10.8747 20.8751 11.1812 21.2814 11.7639 22.0626L11.7883 22.0949C12.3994 22.9045 13.2263 24 14.8 24C16.3771 24 17.1748 22.9407 17.781 22.1356C17.7996 22.111 17.8179 22.0867 17.8361 22.0626C18.4186 21.2814 18.7253 20.8751 19.4 20.8751C20.0747 20.8751 20.3812 21.2814 20.9639 22.0626L20.9883 22.0949Z"
      fill={props.color}
    />
  </svg>
);

SvgDrawLarge.displayName = 'SvgDrawLarge';
const DrawLarge = withForgeIconProps(SvgDrawLarge, {
  name: 'Draw',
  usage:
    'Use to indicate that the user can draw a shape using the trackpad or similar device',
  related: 'N/A',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default DrawLarge;
